<template>
  <div id="app">
    <router-view name="header" />
    <main>
      <fade-transition :duration="250" origin="center" mode="out-in">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer" />
    <modal
      :show.sync="getModalsInfo.modal"
      :modal-classes="`modal-${getModalsInfo.type} modal-dialog-centered`"
      modal-sm
    >
      <template slot="header">
        <h5 class="modal-title">温馨提示</h5>
      </template>
      <div v-html="getModalsInfo.modal_text" />
    </modal>
    <!-- <telegram/> -->
  </div>
</template>
<script>
import { FadeTransition } from 'vue2-transitions'
import Modal from '@/components/Modal.vue'
// import Telegram from '@/components/telegram/index.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    FadeTransition,
    Modal
    // Telegram,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getModalsInfo'])
  }
}
</script>
